export default __webpack_public_path__ + "static/media/CommonInternetWhalingAttacks4.f201532d.png";